import { molsonTheme } from '@theme'
import { molsonStyled, molsonUseTheme } from '@theme/customMuiExports'
import PhoneInputLib, { PhoneInputProps } from 'react-phone-input-2'
import 'react-phone-input-2/lib/material.css'

type PhoneInputModule = {
  default?: React.ComponentType<PhoneInputProps>
} & React.ComponentType<PhoneInputProps>
const PhoneInput =
  (PhoneInputLib as unknown as PhoneInputModule).default ?? PhoneInputLib

type CustomPhoneInputProps = PhoneInputProps & {
  dataTestId?: string
}

const StyledPhoneInput = molsonStyled(PhoneInput)(
  ({ theme }: { theme: typeof molsonTheme }) => ({
    borderRadius: '8px !important',
    height: '49px',
    fontFamily: theme.typography.fontFamily,
    display: 'flex',
    alignItems: 'center',
    boxShadow: '0px 1px 2px rgb(16 24 40 / 5%)',
    border: '1px solid transparent',

    '& .form-control': {
      color: theme.palette.secondary[900],
      lineHeight: '24px',
      fontWeight: theme.typography.fontWeightRegular,
      padding: '10px 14px 10px 70px !important',
      width: '100% !important',
      height: '49px',
      borderRadius: '8px !important',
      transition: 'none !important',
      border: `1px solid ${theme.palette.secondary[300]} !important`,

      '&:focus': {
        borderColor: `${theme.palette.primary.main} !important`,
        boxShadow: `0 0 0 1px ${theme.palette.primary.main} !important`
      }
    },

    '& .flag-dropdown .selected-flag': {
      paddingLeft: 16,
      '& .flag .arrow': {
        left: 35,
        borderLeft: '5px solid transparent !important',
        borderRight: '5px solid transparent !important',
        borderTop: `5px solid ${theme.palette.secondary[500]}`
      },
      '& .flag .arrow.up': {
        borderBottom: `5px solid ${theme.palette.secondary[500]}`,
        borderTop: 'none'
      }
    },

    '& .flag-dropdown .country-list': {
      position: 'fixed !important' as 'fixed',
      minWidth: '250px',
      margin: '0',
      padding: '8px 0',
      borderRadius: '3px !important',
      boxShadow:
        '0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%)',

      '& li': {
        padding: '6px 16px',
        display: 'flex',

        '& .flag': {
          marginTop: '0px !important',
          padding: '0px !important',
          position: 'relative',
          top: 0,
          left: 0
        }
      }
    },

    '& .flag-dropdown .country-list::-webkit-scrollbar': {
      display: 'none !important'
    },

    '&.react-tel-input .special-label': {
      display: 'none'
    }
  })
)

export const CustomPhoneInput = ({
  dataTestId,
  ...props
}: CustomPhoneInputProps) => {
  const theme = molsonUseTheme()
  return (
    <StyledPhoneInput
      placeholder="Enter phone number..."
      data-testid={dataTestId}
      theme={theme}
      {...props}
    />
  )
}
